<template>
  <a :href="link" target="_blank" class="py-1">
    <v-btn
      variant="outlined"
      size="small"
      :color="link?.includes('skype') ? '#06b7ef' : '#7b83eb'"
      style="background-color: white"
    >
      Join
      <template #append>
        <MicrosoftSkype style="height: 20px; width: 20px" v-if="link?.includes('skype')" />
        <MicrosoftTeams style="height: 20px; width: 20px" v-else />
      </template>
      <v-tooltip activator="parent" location="bottom" class="custom-tooltip"
        >Microsoft {{ link?.includes("skype") ? "Skype" : "Teams" }}</v-tooltip
      >
    </v-btn>
  </a>
</template>

<script setup lang="ts">
import MicrosoftTeams from "@/assets/brand/microsoftTeams.svg";
import MicrosoftSkype from "@/assets/brand/microsoftSkype.svg";
defineProps<{ link?: string }>();
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
</style>
